import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import windowEvents from '../hoc/window-events';

var OnClickOutside = /*#__PURE__*/function (_PureComponent) {
  _inherits(OnClickOutside, _PureComponent);

  var _super = _createSuper(OnClickOutside);

  function OnClickOutside() {
    var _this;

    _classCallCheck(this, OnClickOutside);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentRef = function (element) {
      _this.componentNode = element;
    };

    _this.onClick = throttle(function (event) {
      var outsideClick = true;
      var element = event.target;
      var insideBody = false;

      while (element.parentNode) {
        if (element === _this.componentNode) {
          outsideClick = false;
          break;
        }

        if (element === document.body) insideBody = true;
        element = element.parentNode;
      }

      if (!outsideClick || !insideBody) return;

      _this.props.handler(event);
    });
    return _this;
  }

  _createClass(OnClickOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.windowEvents.on('mousedown', this.onClick);
      this.props.windowEvents.on('touchstart', this.onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.windowEvents.removeListener('mousedown', this.onClick);
      this.props.windowEvents.removeListener('touchstart', this.onClick);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.componentRef);
    }
  }]);

  return OnClickOutside;
}(PureComponent);

OnClickOutside.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Функция обработчик
   */
  handler: PropTypes.func.isRequired,

  /**
   * Функция возращающая контент
   */
  children: PropTypes.func.isRequired
} : {};
export default windowEvents('mousedown', 'touchstart')(OnClickOutside);